/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { Grid } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import Toolbar from 'loracoms/Toolbar';
import IntlMsg from 'lorautils/intl/IntlMsg';
import GatewayData from '../GatewayData';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  gatewayId: React.PropTypes.string.isRequired,
  gateway: React.PropTypes.object.isRequired,
};

class StatView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      gateway: props.gateway,
    };
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.datamsgview');
  }

  componentWillReceiveProps(nextProps) {
    const { gateway } = nextProps;
    if (gateway !== this.props.gateway) {
      this.setState({ gateway });
    }
  }

  renderToolbar() {
    const { gateway } = this.state;
    const breadcrumb = [{
      content: this.intlMsg.msg('breadcrumbs.gateways', 'gatewaydetail'),
      onClick: () => this.props.pushState('/gateway'),
    }, {
      content: gateway.name,
      active: true,
    }];

    return (
      <Toolbar breadcrumb={breadcrumb} />
    );
  }

  render() {
    const { gatewayId } = this.props;

    return (
      <Grid fluid>
        {this.renderToolbar()}
        <GatewayData gatewayId={gatewayId} />
      </Grid>
    );
  }
}


StatView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  gateway: state.gateway.gateway.data || {},
  gatewayId: ownProps.params.id,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(StatView));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/DataMsgView/index.jsx